// extracted by mini-css-extract-plugin
export default {"test":"style_test__gchVN"};